import styled from 'styled-components';

import { ButtonStyled } from '../Button/Button.styled';

export const EditInputWrapper = styled.div`
  display: inline-flex;

  ${ButtonStyled} {
    margin: 0 5px;
  }
`;

export const InputStyled = styled.input`
  text-align: center;
  width: 100px;
  padding: 5px;

  ${({ theme }) => `
    color: ${theme.textColour};
    border: 1px solid ${theme.borderColour};
    border-radius: 4px;

    &:focus {
      border-color: ${theme.primaryColour};
    }
  `}

  &[disabled] {
    background-color: transparent;
    pointer-events: none;
  }
`;
